import { createReducer } from 'redux-act';
import { createQuoteSuccess, createQuoteFailure, setLoading, createQuote, clearQuote } from './quoteActions';

const initialState = {
  quote: null,
  isLoading: true,
  error: null,
};

export const reducer = createReducer(
  {
    [createQuote]: (state) => ({ ...state, error: null, isLoading: true }),
    [createQuoteSuccess]: (state, { quote }) => ({
      ...state,
      quote,
    }),
    [createQuoteFailure]: (state, error) => ({ ...state, quote: null, error }),
    [clearQuote]: (state) => ({ ...state, quote: null }),
    [setLoading]: (state, isLoading) => ({ ...state, isLoading }),
  },
  initialState,
);
